<section>
    <app-loader-bnpl *ngIf="loading" [infoMessage]="infoMsg"></app-loader-bnpl>
    <ng-container *ngIf="validAmount; else amountLowAlert">
        <div class="general-title">
            <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
        </div>
        <app-return-methods [itsMobileCtrl]="true" [unique]="this.transaction.ORDER_METHOD"
            (RT)="changeMethod()"></app-return-methods>
        <div class="contentBox">
            <div class="center col-3">
                <div class="info-logo-container">
                    <img [src]="information.logo" class="payment_method_no_interactive __method_brands"
                        alt="cdc-logo" />
                </div>
            </div>
            <div class="col-7">
                <div class="methodInfo">

                    <app-return-methods [itsMobileCtrl]="false" [unique]="this.transaction.ORDER_METHOD"
                        (RT)="changeMethod()"></app-return-methods>
                    <h1>{{ 'transferTitle' | translation | async }}</h1>
                    <form [formGroup]="form">
                        <mat-form-field appearance="outline"
                            [ngClass]="{ disabledInput: isControlReadOnly('titularsName') }">
                            <mat-label>{{ 'cdc-Form-Titulars-Name' | translation | async }} *</mat-label>
                            <input autocomplete="off" type="text"
                                placeholder="{{ 'cdc-Form-Titulars-Name' | translation | async }}" matInput
                                name="titularsName" formControlName="titularsName"
                                [readonly]="isControlReadOnly('titularsName')" />
                        </mat-form-field>
                        <!-- Validators -->
                        <ng-container *ngFor="let validation of errorsMessages.titularsName">
                            <div class="error-message" *ngIf="form.get('titularsName').hasError(validation.type) &&
                                                    (form.get('titularsName').dirty ||
                                                    form.get('titularsName').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                        <mat-form-field appearance="outline"
                            [ngClass]="{ disabledInput: isControlReadOnly('documenType') }">
                            <mat-label>{{ 'forms-TypeDoc-Input' | translation | async }}</mat-label>
                            <mat-select placeholder="{{ 'forms-TypeDoc-Input' | translation | async }}"
                                formControlName="documenType" [readonly]="isControlReadOnly('documenType')"
                                ngDefaulontrol>
                                <mat-option [value]="document.value" *ngFor="let document of listOfDocuments">
                                    {{ document.text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline"
                            [ngClass]="{ disabledInput: isControlReadOnly('documentNumber') }">
                            <mat-label>{{ 'forms-NumDoc-Input' | translation | async }} *</mat-label>
                            <input autocomplete="off" type="text"
                                placeholder="{{ 'forms-NumDoc-Input' | translation | async }}" matInput
                                name="documentNumber" minlength="1" maxlength="15" formControlName="documentNumber"
                                [readonly]="isControlReadOnly('documentNumber')" />
                        </mat-form-field>
                        <!-- Validators -->
                        <ng-container *ngFor="let validation of errorsMessages.documentNumber">
                            <div class="error-message" *ngIf="form.get('documentNumber').hasError(validation.type) &&
                                                    (form.get('documentNumber').dirty ||
                                                    form.get('documentNumber').touched)">
                                {{ validation.message }}
                            </div>
                        </ng-container>
                    </form>
                    <app-privacy-conditions class="privacy-conditions-component" (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>

                </div>
                <app-buttons-bar [valid]="completedForms()" [template]="template" [nameCustom]="buttonMessage"
                    (CUSTOM)="customersLoanValidation()" class="payButton">
                </app-buttons-bar>
            </div>
        </div>
    </ng-container>
</section>
<ng-template #amountLowAlert>
    <app-amount-to-low-alert [transaction]="transaction" [infoOrderCheckout]="infoOrderCheckout"
        (CDC)="changeMethod()"></app-amount-to-low-alert>
</ng-template>
